export const SVEA_MERCHANT_ID = process.env.SVEA_MERCHANT_ID ?? ''
export const SVEA_SECRET_KEY = process.env.SVEA_SECRET_KEY ?? ''
/** @see https://paymentsdocs.svea.com/docs/getting-started/before-you-start */
export const SVEA_API_CHECKOUT_URL = process.env.SVEA_API_CHECKOUT_URL ?? ''
